<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  emits: ['backToAdmin'],
  data() {
    return {
      uporabniki: [],
      izbranUporabnik: null,
      izbranKljuc: null,
      ime: null,
      priimek: null,
      tel: null,
      jezik: null,
      searchUser: '',
      text: '',
      types: '',
      ShowNoti: false,
      brisanje: false,
      geslo: null,
      pGeslo: null,
      sGesla: false,
      posodabljam: false,
    }
  },
  mounted() {
    this.BeriUporabnike();
  },
  computed: {
    FilterUporabnikov() {
      if (this.searchUser !== '') {
        return this.uporabniki.filter(uporabnik =>
            uporabnik.ime.toLowerCase().includes(this.searchUser.toLowerCase()) ||
            uporabnik.priimek.toLowerCase().includes(this.searchUser.toLowerCase()));
      } else {
        return this.uporabniki;
      }
    },
  },
  methods: {
    BeriUporabnike() {
      axios.get('./api/uporabniki/izpis/', {withCredentials: true}).then((response) => {
        this.uporabniki = response.data.uporabniki;
      }).catch((napaka) => {
        this.text = "Prišlo je do napake pri pridobivanju podatkov";
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    UrediUporabnika(id) {
      this.izbranUporabnik = id;
      for (let i = 0; i < this.uporabniki.length; i++) {
        if (this.uporabniki[i].id === id) {
          this.izbranKljuc = i;
          break;
        }
      }
      this.ime = this.uporabniki[this.izbranKljuc].ime;
      this.priimek = this.uporabniki[this.izbranKljuc].priimek;
      this.tel = this.uporabniki[this.izbranKljuc].tel;
      this.jezik = this.uporabniki[this.izbranKljuc].jezik;
    },
    BrisiUporabnika(id) {
      this.brisanje = true;
      this.izbranUporabnik = id;
      this.text = "Ste prepričani, da želite izbrisati uporabnika? Pozor! uporabnik ne bo več imel dostopa do aplikacije.";
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    Brisi() {
      let podatki = new URLSearchParams();
      podatki.append('uID', this.izbranUporabnik);
      let noviUporabniki = [];
      axios.post('./api/uporabniki/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
        for (let i = 0; i < this.uporabniki.length; i++) {
          if (this.uporabniki[i].id !== this.izbranUporabnik) {
            noviUporabniki.push(this.uporabniki[i]);
          }
        }
        this.uporabniki = noviUporabniki;
        this.izbranUporabnik = null;
        this.brisanje = false;
      }).catch((napaka) => {
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }

      });
    },
    Cancel() {
      this.ShowNoti = false;
      this.izbranUporabnik = null;
      this.brisanje = false;
    },
    Validate() {
      this.posodabljam = true;
      if (this.ime !== '' && this.priimek !== '' && this.tel !== '') {
        let podatki = new URLSearchParams();
        podatki.append('uID', this.izbranUporabnik);
        podatki.append('ime', this.ime);
        podatki.append('priimek', this.priimek);
        podatki.append('tel', this.tel);
        podatki.append('jezik', this.jezik);
        if(this.sGesla) {
          if(this.pGeslo === this.geslo) {
            podatki.append('geslo', this.geslo);
          }else {
            this.posodabljam = false;
            this.text = "Geslo in potrditveno geslo se ne ujemata.";
            this.types = "Napaka";
            this.ShowNoti = true;
            return;
          }
        }
        axios.post('./api/uporabniki/uredi/', podatki, {withCredentials: true}).then((response) => {
          this.text = response.data.sporocilo;
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.uporabniki[this.izbranKljuc].ime = this.ime;
          this.uporabniki[this.izbranKljuc].priimek = this.priimek;
          this.uporabniki[this.izbranKljuc].tel = this.tel;
          this.uporabniki[this.izbranKljuc].jezik = this.jezik;
          this.izbranUporabnik = null;
          this.ime = null;
          this.priimek = null;
          this.tel = null;
          this.jezik = null;
          this.geslo = null;
          this.pGeslo = null;
          this.sGesla = false;
          this.posodabljam = false;
        }).catch((napaka) => {
          this.posodabljam = false;
          if (napaka !== undefined && napaka.response.data.napaka !== null) {
            this.text = napaka.response.data.napaka;
            this.types = "Napaka";
            this.ShowNoti = true;
          } else {
            this.text = napaka;
            this.types = "Napaka";
            this.ShowNoti = true;
          }

        });
      } else {
        this.text = "Za posodabljanje zapisov morajo biti izpolnjena vsa polja.";
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    ZapriUrejanje() {
      this.izbranUporabnik = null;
      this.ime = null;
      this.priimek = null;
      this.tel = null;
      this.jezik = null;
    },
    vrniNaziv(lvl) {
      switch (lvl) {
        case 0:
          return 'Administrator';
        case 1:
          return 'Upravitelj';
        case 2:
          return 'Instruktor';
        case 3:
          return 'Kronometrist';
        default:
          return 'Pilot';
      }
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <main class="main-content" >
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="section-title">
            <h3>Upravljanje uporabniških računov</h3>
            <!-- <p>Osnovne informacije o letališču</p> -->
          </div>
        </div>
        <div class="section-content">
          <p class='text-white'>Urejanje in brisanje uporabniških računov aplikacije. <span class='text-danger'>Izbrisani uporabniki bodo deaktivirani.</span></p>
        </div>
      </div>
      <div class="col-12 sticky">
        <div class="container">
          <input class="input border-1 rounded-4 p-2 fs-5" type="text" placeholder="vnesi ime ali priimek uporabnika" v-model="searchUser" /> <i class="fas fa-search iskalnik"></i><br/>
        </div>
      </div>
      <!-- KARTICA UPORABNIKA -->
      <div
          class="user-card"
          v-for="(user, key) in FilterUporabnikov"
          :key="user.id"
          :class="{ 'user-card-editing': izbranUporabnik === user.id && !brisanje }"
      >

        <!-- GLAVA -->
        <div class="user-card-header">

          <div class="user-settings-info">

            <div class="user-avatar">
        <span>
          {{ user.ime.charAt(0) }}{{ user.priimek.charAt(0) }}
        </span>
            </div>

            <div class="user-details">
              <h3>
                {{ user.ime }} {{ user.priimek }}
              </h3>

              <span class="user-status">
                <span class="status-dot"></span>
                {{  vrniNaziv(user.lvl) }}
              </span>
            </div>

          </div>


          <!-- ACTIONS -->
          <div class="user-actions">

            <!-- PREKLIČI -->
            <button
                v-if="izbranUporabnik === user.id && !brisanje"
                class="user-action user-action-cancel"
                title="Prekliči urejanje"
                @click.prevent="ZapriUrejanje()"
            >
              <i class="fas fa-times"></i>
            </button>

            <!-- UREDI -->
            <button
                v-if="(izbranUporabnik == null || izbranUporabnik !== user.id) && !brisanje"
                class="user-action user-action-edit"
                title="Uredi uporabnika"
                @click.prevent="UrediUporabnika(user.id)"
            >
              <i class="fas fa-pen"></i>
            </button>

            <!-- IZBRIŠI -->
            <button
                class="user-action user-action-delete"
                title="Izbriši uporabnika"
                @click.prevent="BrisiUporabnika(user.id)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>

          </div>

        </div>

        <!-- OBRAZEC ZA UREJANJE -->
        <div
            class="user-card-content"
            v-if="izbranUporabnik === user.id && !brisanje"
        >

          <div class="user-form-grid">

            <!-- IME -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Ime
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="ime"
                    required
                />
              </div>
            </div>

            <!-- PRIIMEK -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Priimek
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="priimek"
                    required
                />
              </div>
            </div>

            <!-- TELEFON -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Telefon
              </label>

              <div class="modern-input-group">
                <i class="fas fa-phone"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="text"
                    v-model="tel"
                    required
                />
              </div>
            </div>

            <!-- JEZIK -->
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Jezik vmesnika
              </label>

              <div class="modern-input-group">
                <i class="fas fa-language"></i>

                <select
                    class="users-modern-form-input"
                    v-model="jezik"
                >
                  <option value="sl">Slovenščina</option>
                  <option value="it">Italiano</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>
            <div class="modern-form-group">
              <label class="user-modern-form-label">
                Želite spremeniti geslo? <span class="text-warning">{{ sGesla ? 'Da' : 'Ne' }}</span>
              </label>
              <input
                  class=""
                  type="checkbox"
                  v-model="sGesla"
              />
            </div>
            <div class="modern-form-group"></div>
            <!-- GESLO -->
            <div class="modern-form-group" v-if="sGesla">
              <label class="user-modern-form-label">
                Geslo
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user-lock"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="password"
                    v-model="geslo"
                    required
                />
              </div>
            </div>
            <div class="modern-form-group" v-if="sGesla">
              <label class="user-modern-form-label">
                Potrditev gesla
              </label>

              <div class="modern-input-group">
                <i class="fas fa-user-lock"></i>

                <input
                    class="users-modern-form-input"
                    autocomplete="off"
                    type="password"
                    v-model="pGeslo"
                    required
                />
              </div>
            </div>

          </div>

          <!-- GUMBI -->
          <div class="users-modern-form-actions">

            <button
                class="users-modern-btn modern-btn-secondary"
                @click.prevent="ZapriUrejanje()"
            >
              Prekliči
            </button>

            <button
                class="users-modern-btn users-modern-btn-primary"
                @click.prevent="Validate()"
                :disabled="posodabljam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': posodabljam}"></i>
              Posodobi
            </button>

          </div>

        </div>

      </div>
    </main>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da='Brisi()' @ne='Cancel()' @closeNotification="ShowNoti = false" />
  </Transition>
</template>
<style>
/* =========================================
   USER CARD
========================================= */

.user-card {
  width: 100%;
  margin-bottom: 12px;

  background: #19232c;
  border: 1px solid #293641;
  border-radius: 14px;

  overflow: hidden;

  transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease,
      transform 0.2s ease;
}

.user-card:hover {
  border-color: #354552;
}

.user-card-editing {
  border-color: #2563eb;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
}


/* =========================================
   HEADER
========================================= */

.user-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px 20px;
}


/* =========================================
   USER INFO
========================================= */

.user-settings-info {
  display: flex;
  align-items: center;

  min-width: 0;
}


/* Avatar */

.user-avatar {
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 50%;

  background: linear-gradient(
      135deg,
      #2563eb,
      #3b82f6
  );

  color: #ffffff;

  font-size: 13px;
  font-weight: 600;

  box-shadow:
      0 4px 10px rgba(37, 99, 235, 0.25);
}

.user-avatar span {
  text-transform: uppercase;
}


/* User details */

.user-details {
  margin-left: 12px;

  min-width: 0;
}

.user-details h3 {
  margin: 0;

  font-size: 15px;
  font-weight: 600;

  color: #f1f5f9;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-status {
  display: flex;
  align-items: center;

  margin-top: 4px;

  font-size: 12px;
  color: #7f8d99;
}

.status-dot {
  width: 6px;
  height: 6px;

  margin-right: 6px;

  border-radius: 50%;

  background: #22c55e;

  box-shadow:
      0 0 0 3px rgba(34, 197, 94, 0.1);
}


/* =========================================
   ACTION BUTTONS
========================================= */

.user-actions {
  display: flex;
  align-items: center;
  gap: 6px;

  margin-left: 16px;
}

.user-action {
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid transparent;
  border-radius: 8px;

  background: transparent;

  font-size: 13px;

  cursor: pointer;

  transition:
      background-color 0.15s ease,
      color 0.15s ease,
      border-color 0.15s ease;
}


/* Edit */

.user-action-edit {
  color: #60a5fa;
}

.user-action-edit:hover {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.2);
}


/* Cancel */

.user-action-cancel {
  color: #94a3b8;
}

.user-action-cancel:hover {
  background: rgba(148, 163, 184, 0.1);
  color: #e2e8f0;
}


/* Delete */

.user-action-delete {
  color: #f87171;
}

.user-action-delete:hover {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.2);
}


/* =========================================
   EDIT CONTENT
========================================= */

.user-card-content {
  padding: 0 20px 20px;

  border-top: 1px solid #293641;

  background: #18222b;

  animation: userFormIn 0.2s ease-out;
}

@keyframes userFormIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


/* =========================================
   FORM GRID
========================================= */

.user-form-grid {
  display: grid;

  grid-template-columns: repeat(2, minmax(0, 1fr));

  gap: 16px;

  padding-top: 20px;
}


/* =========================================
   FORM GROUP
========================================= */

.modern-form-group {
  width: 100%;
}

.user-modern-form-label {
  display: block;

  margin-bottom: 7px;

  font-size: 12px;
  font-weight: 500;

  color: #9aa8b5;
}


/* =========================================
   INPUT
========================================= */
.modern-input-group > i {
  position: absolute;

  left: 12px;

  z-index: 1;

  color: #687886;

  font-size: 12px;

  pointer-events: none;
}

.users-modern-form-input {
  width: 100%;
  height: 40px;

  padding: 0 12px 0 34px;

  color: #e5edf3;

  background: #121a21;

  border: 1px solid #303e49;
  border-radius: 8px;

  outline: none;

  font-size: 13px;

  transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      background-color 0.15s ease;
}

.users-modern-form-input:hover {
  border-color: #3b4b57;
}

.users-modern-form-input:focus {
  background: #141e26;

  border-color: #3b82f6;

  box-shadow:
      0 0 0 3px rgba(59, 130, 246, 0.12);
}

.users-modern-form-input::placeholder {
  color: #596875;
}


/* Select */

select.users-modern-form-input {
  appearance: none;

  cursor: pointer;
}


/* =========================================
   FORM ACTIONS
========================================= */

.users-modern-form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  gap: 8px;

  margin-top: 20px;
  padding-top: 16px;

  border-top: 1px solid #293641;
}


/* =========================================
   BUTTONS
========================================= */

.users-modern-btn {
  height: 38px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  padding: 0 15px;

  border-radius: 8px;

  font-size: 13px;
  font-weight: 500;

  cursor: pointer;

  transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      transform 0.1s ease;
}

.users-modern-btn:active {
  transform: translateY(1px);
}


/* Secondary */

.modern-btn-secondary {
  color: #aab6c0;

  background: transparent;

  border: 1px solid #35434e;
}

.modern-btn-secondary:hover {
  color: #e2e8f0;

  background: #202c36;

  border-color: #465662;
}


/* Primary */

.users-modern-btn-primary {
  color: #ffffff;

  background: #2563eb;

  border: 1px solid #2563eb;

  box-shadow:
      0 3px 8px rgba(37, 99, 235, 0.2);
}

.users-modern-btn-primary:disabled {
  background: rgb(37 99 235 / 0.27);
  opacity: 0.65;
  cursor: not-allowed;
  pointer-events: none;
}
.users-modern-btn-primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;

  box-shadow:
      0 4px 12px rgba(37, 99, 235, 0.3);
}


/* =========================================
   MOBILE
========================================= */

@media (max-width: 650px) {

  .user-card-header {
    padding: 14px 16px;
  }

  .user-card-content {
    padding: 0 16px 16px;
  }

  .user-form-grid {
    grid-template-columns: 1fr;

    gap: 12px;
  }

  .user-details h3 {
    max-width: 180px;
  }

  .users-modern-form-actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .users-modern-btn {
    width: 100%;
  }
}

</style>